export default "__VITE_ASSET__DWkh8_DN__"